__turbopack_context__.v({
  "glass": "ThemeToggle-module__sGqMhG__glass",
  "icon": "ThemeToggle-module__sGqMhG__icon",
  "label": "ThemeToggle-module__sGqMhG__label",
  "toggle": "ThemeToggle-module__sGqMhG__toggle",
});
